var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveanimals6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.75C15.8424 23.75 14.2527 23.0915 13.0806 21.9194C11.9085 20.7473 11.25 19.1576 11.25 17.5C11.25 15.8424 11.9085 14.2527 13.0806 13.0806C14.2527 11.9085 15.8424 11.25 17.5 11.25C19.1576 11.25 20.7473 11.9085 21.9194 13.0806C23.0915 14.2527 23.75 15.8424 23.75 17.5C23.75 18.3208 23.5883 19.1335 23.2742 19.8918C22.9602 20.6501 22.4998 21.3391 21.9194 21.9194C21.3391 22.4998 20.6501 22.9602 19.8918 23.2742C19.1335 23.5883 18.3208 23.75 17.5 23.75ZM17.5 0C12.8587 0 8.40752 1.84374 5.12563 5.12563C1.84374 8.40752 0 12.8587 0 17.5C0 30.625 17.5 50 17.5 50C17.5 50 35 30.625 35 17.5C35 12.8587 33.1563 8.40752 29.8744 5.12563C26.5925 1.84374 22.1413 0 17.5 0Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveanimals6);
export default __webpack_public_path__ + "static/media/liveanimals6.91ad7f63201e4e979781e37af10b2cdf.svg";
export { ForwardRef as ReactComponent };